let lockDepth = 0;
let previousBodyOverflow = "";

export function lockBodyScroll(): void {
  if (typeof document === "undefined") {
    return;
  }

  if (lockDepth === 0) {
    previousBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }

  lockDepth += 1;
}

export function unlockBodyScroll(): void {
  if (typeof document === "undefined" || lockDepth <= 0) {
    return;
  }

  lockDepth -= 1;

  if (lockDepth === 0) {
    document.body.style.overflow = previousBodyOverflow;
  }
}
